if (!customElements.get("variant-selects")) {
	/**
	 *  @class
	 *  @function VariantSelects
	 */
	class VariantSelects extends HTMLElement {
		constructor() {
			super();
			this.sticky = this.dataset.sticky;
			this.updateUrl = this.dataset.updateUrl === "true";
			this.isDisabledFeature = this.dataset.isDisabled;
			this.addEventListener("change", this.onVariantChange);
			this.other = Array.from(document.querySelectorAll("variant-selects")).filter((selector) => {
				return selector != this;
			});

			this.productWrapper = this.closest(".thb-product-detail");
			this.productSlider = this.productWrapper.querySelector(".product-images");
			this.thumbnails = this.productWrapper.querySelector(".product-thumbnail-container");
			this.hideVariants = this.dataset.hideVariants === "true";

			this.addEventListener("mousedown", (e) => {
				if (e.target.tagName === "LABEL") {
					const scrollY = window.scrollY;
					requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: "instant" }));
				}
			});
		}

		connectedCallback() {
			this.updateOptions();
			this.updateMasterId();
			this.setDisabled();
			this.setImageSet();
			this.prefetchProductUrls();
		}

		onVariantChange(e) {
			this.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, "", false);
			this.removeErrorMessage();
			this.updateVariantText();

			this.updateMediaFromInput(e);
			this.renderVariantInfo();

			this.updateOther();
			dispatchCustomEvent("product:variant-change", {
				variant: this.currentVariant,
				sectionId: this.dataset.section,
				variantTitle: this.options.join(" / "),
			});
		}

		updateMediaFromInput(e) {
			if (!e || !e.target) return;
			const input = e.target.closest("input, select, option") || e.target;
			let mediaId;
			if (input.tagName === "SELECT") {
				const selected = input.selectedOptions[0];
				mediaId = selected && selected.dataset.featuredMediaId;
			} else {
				mediaId = input.dataset.featuredMediaId;
			}
			if (!mediaId) return;

			let thumbnails = this.productWrapper.querySelector(".product-thumbnail-container");
			this.setActiveMedia(
				`#Slide-${this.dataset.section}-${mediaId}`,
				`#Thumb-${this.dataset.section}-${mediaId}`,
				this.productSlider,
				thumbnails,
			);
		}

		updateOptions() {
			this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
			this.options = [];
			this.fieldsets.forEach((fieldset, i) => {
				if (fieldset.querySelector("select")) {
					this.options.push(fieldset.querySelector("select").value);
				} else if (fieldset.querySelectorAll("input").length) {
					this.options.push(fieldset.querySelector("input:checked").value);
				}
			});
		}
		updateVariantText() {
			const fieldsets = Array.from(this.querySelectorAll("fieldset"));
			fieldsets.forEach((item, i) => {
				let label = item.querySelector(".form__label__value");
				if (label) {
					label.innerHTML = this.options[i];
				}
			});
		}
		updateMasterId() {
			const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
			if (!span) return;
			this.currentVariant = {
				id: parseInt(span.dataset.variantId, 10) || null,
				available: span.dataset.available === "true",
				featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null,
			};
		}

		updateOther() {
			if (this.dataset.updateUrl === "false") {
				return;
			}
			if (this.other.length) {
				let fieldsets = this.other[0].querySelectorAll("fieldset"),
					fieldsets_array = Array.from(fieldsets);
				this.options.forEach((option, i) => {
					if (fieldsets_array[i].querySelector("select")) {
						fieldsets_array[i].querySelector(`select`).value = option;
					} else if (fieldsets_array[i].querySelectorAll("input").length) {
						fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
					}
				});
				this.other[0].updateOptions();
				this.other[0].updateMasterId();
				this.other[0].updateVariantText();
				this.other[0].setDisabled();
			}
		}

		updateMedia() {
			if (!this.currentVariant) return;
			if (!this.currentVariant.featured_media) return;

			let thumbnails = this.productWrapper.querySelector(".product-thumbnail-container");

			this.setActiveMedia(
				`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				`#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				this.productSlider,
				thumbnails,
			);
		}
		setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
			let flkty = Flickity.data(productSlider),
				activeMedia = productSlider.querySelector(mediaId);

			if (flkty && this.hideVariants) {
				if (productSlider.querySelector(".product-images__slide.is-initial-selected")) {
					productSlider
						.querySelector(".product-images__slide.is-initial-selected")
						.classList.remove("is-initial-selected");
				}
				[].forEach.call(productSlider.querySelectorAll(".product-images__slide-item--variant"), function (el) {
					el.classList.remove("is-active");
				});
				if (this.thumbnails) {
					if (this.thumbnails.querySelector(".product-thumbnail.is-initial-selected")) {
						this.thumbnails
							.querySelector(".product-thumbnail.is-initial-selected")
							.classList.remove("is-initial-selected");
					}
					[].forEach.call(this.thumbnails.querySelectorAll(".product-images__slide-item--variant"), function (el) {
						el.classList.remove("is-active");
					});
				}

				activeMedia.classList.add("is-active");
				activeMedia.classList.add("is-initial-selected");

				this.setImageSetMedia();

				if (thumbnails) {
					let activeThumb = thumbnails.querySelector(thumbId);

					activeThumb.classList.add("is-active");
					activeThumb.classList.add("is-initial-selected");
				}

				productSlider.reInit(this.imageSetIndex);
				productSlider.selectCell(mediaId);
			} else if (flkty) {
				productSlider.selectCell(mediaId);
			}
		}

		updateURL() {
			if (!this.currentVariant || this.dataset.updateUrl === "false") return;
			window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}

		updateShareUrl() {
			const shareButton = document.getElementById(`Share-${this.dataset.section}`);
			if (!shareButton) return;
			shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
		}

		updateVariantInput() {
			const productForms = document.querySelectorAll(
				`#product-form-${this.dataset.section}, #product-form-installment`,
			);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(
					new Event("change", {
						bubbles: true,
					}),
				);
			});
		}

		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector(".pickup-availability-wrapper");
			if (!pickUpAvailability) return;
			pickUpAvailability.update(this.currentVariant);
		}

		removeErrorMessage() {
			const section = this.closest("section");
			if (!section) return;

			const productForm = section.querySelector("product-form");
			if (productForm) productForm.handleErrorMessage();
		}

		getSectionsToRender() {
			return [
				`price-${this.dataset.section}`,
				`price-${this.dataset.section}--sticky`,
				`product-image-${this.dataset.section}--sticky`,
				`inventory-${this.dataset.section}`,
				`sku-${this.dataset.section}`,
				`quantity-${this.dataset.section}`,
			];
		}

		getSelectedValueIds() {
			return this.fieldsets
				.map((fieldset) => {
					if (fieldset.querySelector("select")) {
						return fieldset.querySelector("select").selectedOptions[0]?.dataset.valueId;
					}
					return fieldset.querySelector("input:checked")?.dataset.valueId;
				})
				.filter(Boolean);
		}

		prefetchProductUrls() {
			this._prefetchCache = this._prefetchCache || new Map();
			this.querySelectorAll("[data-product-url]").forEach((el) => {
				let url = el.dataset.productUrl;
				if (url === this.dataset.url) return;
				let label = el.tagName === "OPTION" ? el.closest("select") : el.nextElementSibling;
				if (!label) return;
				label.addEventListener(
					"mouseenter",
					() => {
						if (this._prefetchCache.has(url)) return;
						let fetchUrl = `${url}?section_id=${this.dataset.section}`;
						this._prefetchCache.set(
							url,
							fetch(fetchUrl).then((r) => r.text()),
						);
					},
					{ once: true },
				);
			});
		}

		getProductUrl() {
			for (let fieldset of this.fieldsets) {
				let select = fieldset.querySelector("select");
				let selected = select ? select.selectedOptions[0] : fieldset.querySelector("input:checked");
				if (selected && selected.dataset.productUrl && selected.dataset.productUrl !== this.dataset.url) {
					return selected.dataset.productUrl;
				}
			}
			return null;
		}

		switchProduct(productUrl) {
			this.toggleAddButton(true, "", false);
			const sectionId = this.dataset.section;
			const cached = this._prefetchCache && this._prefetchCache.get(productUrl);
			const request = cached || fetch(`${productUrl}?section_id=${sectionId}`).then((r) => r.text());

			request.then((html) => {
				const doc = new DOMParser().parseFromString(html, "text/html");
				const newContent = doc.getElementById(`shopify-section-${sectionId}`);
				const currentSection = document.getElementById(`shopify-section-${sectionId}`);

				if (newContent && currentSection) {
					currentSection.innerHTML = newContent.innerHTML;
				}

				history.replaceState({}, "", productUrl);
			});
		}

		renderVariantInfo() {
			const productUrl = this.getProductUrl();
			if (productUrl) {
				this.switchProduct(productUrl);
				return;
			}

			const ids = this.getSelectedValueIds();
			if (!ids.length) return;

			const scrollY = window.scrollY;

			fetch(`${this.dataset.url}?option_values=${ids.join(",")}&section_id=${this.dataset.section}`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, "text/html");

					// 0. Combined listings: check if response is a different product
					const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
					if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
						this.switchProduct(span.dataset.productUrl);
						return;
					}

					// 1. Resolve variant from hidden span
					if (span && parseInt(span.dataset.variantId, 10)) {
						this.currentVariant = {
							id: parseInt(span.dataset.variantId, 10),
							available: span.dataset.available === "true",
							featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null,
						};
					} else {
						this.currentVariant = null;
					}

					// 2. Sync data-available onto current DOM inputs (drives setDisabled)
					const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
					if (sourceSelects) {
						sourceSelects.querySelectorAll("[data-value-id]").forEach((sourceEl) => {
							const vid = sourceEl.dataset.valueId;
							const avail = sourceEl.dataset.available;
							[this, ...this.other].forEach((el) => {
								const localEl = el.querySelector(`[data-value-id="${vid}"]`);
								if (localEl) localEl.dataset.available = avail;
							});
						});
					}

					// 3. Update price, inventory, sku sections
					this.getSectionsToRender().forEach((id) => {
						const destination = document.getElementById(id);
						const source = html.getElementById(id);
						if (source && destination) destination.innerHTML = source.innerHTML;
						if (id.includes("price") && destination) destination.classList.remove("visibility-hidden");
					});

					// 4. Apply updated state
					if (!this.currentVariant) {
						this.toggleAddButton(true, "", true);
						this.setUnavailable();
						this.updatePickupAvailability();
						window.scrollTo({ top: scrollY, behavior: "instant" });
						return;
					}
					this.setDisabled();
					this.updateVariantInput();
					if (this.updateUrl) this.updateURL();
					this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
					this.updateMedia();
					this.updatePickupAvailability();
					window.scrollTo({ top: scrollY, behavior: "instant" });
				});
		}

		toggleAddButton(disable = true, text = false, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.dataset.section}`);
			if (!productForm) return;

			const productTemplate = productForm.closest(".product-form").getAttribute("template");
			const submitButtons = document.querySelectorAll(".single-add-to-cart-button");

			if (!submitButtons) return;
			submitButtons.forEach((submitButton) => {
				const submitButtonText = submitButton.querySelector(".single-add-to-cart-button--text");

				if (!submitButtonText) return;

				if (disable) {
					submitButton.setAttribute("disabled", "disabled");
					if (text) submitButtonText.textContent = text;
				} else {
					submitButton.removeAttribute("disabled");
					submitButton.classList.remove("loading");

					if (productTemplate?.includes("pre-order")) {
						submitButtonText.textContent = window.theme.variantStrings.preOrder;
					} else {
						submitButtonText.textContent = window.theme.variantStrings.addToCart;
					}
				}
			});

			if (!modifyClass) return;
		}

		setUnavailable() {
			const submitButtons = document.querySelectorAll(".single-add-to-cart-button");
			const price = document.getElementById(`price-${this.dataset.section}`);
			const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

			submitButtons.forEach((submitButton) => {
				const submitButtonText = submitButton.querySelector(".single-add-to-cart-button--text");
				if (!submitButton) return;
				submitButtonText.textContent = window.theme.variantStrings.unavailable;
				submitButton.classList.add("sold-out");
			});
			if (price) price.classList.add("visibility-hidden");
			if (price_fixed) price_fixed.classList.add("visibility-hidden");
		}

		setDisabled() {
			if (this.isDisabledFeature != "true") return;

			this.fieldsets.forEach((fieldset) => {
				if (fieldset.querySelector("select")) {
					fieldset.querySelectorAll("option").forEach((opt) => {
						opt.disabled = opt.dataset.available === "false";
					});
				} else {
					fieldset.querySelectorAll("input").forEach((input) => {
						input.classList.toggle("is-disabled", input.dataset.available === "false");
					});
				}
			});
			return true;
		}

		getImageSetName(variant_name) {
			return variant_name
				.toLowerCase()
				.replace(/[^a-z0-9]+/g, "-")
				.replace(/-$/, "")
				.replace(/^-/, "");
		}

		setImageSet() {
			if (!this.productSlider) return;

			let dataSetEl = this.productSlider.querySelector("[data-set-name]");
			if (dataSetEl) {
				this.imageSetName = dataSetEl.dataset.setName;
				this.imageSetIndex = this.querySelector(
					'.product-form__input[data-handle="' + this.imageSetName + '"]',
				).dataset.index;
				this.dataset.imageSetIndex = this.imageSetIndex;
				this.setImageSetMedia();
			}
		}
		setImageSetMedia() {
			if (!this.imageSetIndex) {
				return;
			}

			const optionPosition = parseInt(this.imageSetIndex.replace("option", ""), 10) - 1;
			let setValue = this.getImageSetName(this.options[optionPosition]);
			let group = this.imageSetName + "_" + setValue;
			let selected_set_images = this.productWrapper.querySelectorAll(
					`.product-images__slide[data-set-name="${this.imageSetName}"]`,
				),
				selected_set_thumbs = this.productWrapper.querySelectorAll(
					`.product-thumbnail[data-set-name="${this.imageSetName}"]`,
				);
			if (this.hideVariants) {
				// Product images
				this.productWrapper.querySelectorAll(".product-images__slide").forEach((thumb) => {
					if (thumb.dataset.group && thumb.dataset.group !== group) {
						thumb.classList.remove("is-active");
					}
				});
				selected_set_images.forEach((thumb) => {
					thumb.classList.toggle("is-active", thumb.dataset.group === group);
				});

				// Product thumbnails
				this.productWrapper.querySelectorAll(".product-thumbnail").forEach((thumb) => {
					if (thumb.dataset.group && thumb.dataset.group !== group) {
						thumb.classList.remove("is-active");
					}
				});
				selected_set_thumbs.forEach((thumb) => {
					thumb.classList.toggle("is-active", thumb.dataset.group === group);
				});
			}
		}
	}
	customElements.define("variant-selects", VariantSelects);

	/**
	 *  @class
	 *  @function VariantRadios
	 */
	class VariantRadios extends VariantSelects {
		constructor() {
			super();
		}

		updateOptions() {
			const fieldsets = Array.from(this.querySelectorAll("fieldset"));
			this.options = fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
			});
		}
	}

	customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
	/**
	 *  @class
	 *  @function ProductSlider
	 */
	class ProductSlider extends HTMLElement {
		constructor() {
			super();

			this.addEventListener("change", this.setupProductGallery);
		}
		connectedCallback() {
			this.product_container = this.closest(".thb-product-detail");
			this.thumbnail_container = this.product_container.querySelector(".product-thumbnail-container");
			this.video_containers = this.querySelectorAll(".product-single__media-external-video--play");

			this.setOptions();
			// Start Slider
			this.init();
		}
		setOptions() {
			this.hide_variants = this.dataset.hideVariants == "true";
			this.thumbnails = this.thumbnail_container.querySelectorAll(".product-thumbnail");
			this.prev_button = this.querySelector(".flickity-prev");
			this.next_button = this.querySelector(".flickity-next");
			// Auto-rotate is mobile only (< 768px, theme's main breakpoint).
			this.mobile_query = this.mobile_query || window.matchMedia("(max-width: 767px)");
			this.autoplay_mobile =
				this.dataset.autoplayMobile === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			this.autoplay_interval = (parseFloat(this.dataset.autoplayIntervalMobile) || 4) * 1000;
			this.options = {
				wrapAround: true,
				pageDots: true,
				contain: true,
				adaptiveHeight: true,
				initialIndex: ".is-initial-selected",
				prevNextButtons: false,
				fade: false,
				cellSelector: ".product-images__slide.is-active",
				autoPlay: this.autoplay_mobile && this.mobile_query.matches ? this.autoplay_interval : false,
			};
		}
		init() {
			this.flkty = new Flickity(this, this.options);

			this.selectedIndex = this.flkty.selectedIndex;

			// Setup Events
			this.setupEvents();

			// Start Gallery
			this.setupProductGallery();
		}
		reInit(imageSetIndex) {
			this.flkty.destroy();

			this.setOptions();

			this.flkty = new Flickity(this, this.options);

			// Setup Events
			this.setupEvents();

			this.selectedIndex = this.flkty.selectedIndex;
		}
		setupEvents() {
			const _this = this;
			if (this.prev_button) {
				let prev = this.prev_button.cloneNode(true);
				this.prev_button.parentNode.append(prev);
				this.prev_button.remove();
				prev.addEventListener("click", (event) => {
					this.stopAutoplay();
					this.flkty.previous();
				});
				prev.addEventListener("keyup", (event) => {
					this.stopAutoplay();
					this.flkty.previous();
					event.preventDefault();
				});
			}
			if (this.next_button) {
				let next = this.next_button.cloneNode(true);
				this.next_button.parentNode.append(next);
				this.next_button.remove();
				next.addEventListener("click", (event) => {
					this.stopAutoplay();
					this.flkty.next();
				});
				next.addEventListener("keyup", (event) => {
					this.stopAutoplay();
					this.flkty.next();
					event.preventDefault();
				});
			}
			this.video_containers.forEach((container) => {
				container.querySelector("button").addEventListener("click", () => {
					container.setAttribute("hidden", "");
					// Don't rotate away from a video the visitor just started.
					this.stopAutoplay();
				});
			});
			this.setupAutoplay();
			this.flkty.on("settle", function (index) {
				_this.selectedIndex = index;
			});
			this.flkty.on("change", (index) => {
				let previous_slide = this.flkty.cells[_this.selectedIndex].element,
					previous_media = previous_slide.querySelector(".product-single__media"),
					active_thumbs = Array.from(this.thumbnails).filter((element) => element.classList.contains("is-active")),
					active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

				this.thumbnails.forEach((item, i) => {
					item.classList.remove("is-initial-selected");
				});
				active_thumb.classList.add("is-initial-selected");

				requestAnimationFrame(() => {
					if (active_thumb.offsetParent === null) {
						return;
					}
					const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
						windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
					active_thumb.parentElement.scrollTo({
						left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
						top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
						behavior: "smooth",
					});
				});

				// Stop previous video
				if (previous_media.classList.contains("product-single__media-external-video")) {
					if (previous_media.dataset.provider === "youtube") {
						previous_media.querySelector("iframe").contentWindow.postMessage(
							JSON.stringify({
								event: "command",
								func: "pauseVideo",
								args: "",
							}),
							"*",
						);
					} else if (previous_media.dataset.provider === "vimeo") {
						previous_media.querySelector("iframe").contentWindow.postMessage(
							JSON.stringify({
								method: "pause",
							}),
							"*",
						);
					}
					previous_media.querySelector(".product-single__media-external-video--play").removeAttribute("hidden");
				} else if (previous_media.classList.contains("product-single__media-native-video")) {
					previous_media.querySelector("video").pause();
				}
			});

			setTimeout(() => {
				let active_thumbs = Array.from(this.thumbnails).filter((element) => element.clientWidth > 0);
				active_thumbs.forEach((thumbnail, index) => {
					thumbnail.addEventListener("click", () => {
						this.thumbnailClick(thumbnail, index);
					});
				});
			});
		}
		setupAutoplay() {
			if (!this.autoplay_mobile || this.autoplay_bound) {
				return;
			}
			this.autoplay_bound = true;
			// Native videos: pause rotation as soon as one starts playing.
			this.addEventListener("play", () => this.stopAutoplay(), true);
			// Keep rotation in sync when crossing the mobile breakpoint (resize / rotate).
			this.mobile_query.addEventListener("change", (event) => {
				if (!this.flkty) {
					return;
				}
				if (event.matches) {
					this.flkty.options.autoPlay = this.autoplay_interval;
					this.flkty.playPlayer();
				} else {
					this.stopAutoplay();
				}
			});
		}
		stopAutoplay() {
			if (!this.flkty) {
				return;
			}
			this.flkty.options.autoPlay = false;
			this.flkty.stopPlayer();
		}
		thumbnailClick(thumbnail, index) {
			this.stopAutoplay();
			[].forEach.call(this.thumbnails, function (el) {
				el.classList.remove("is-initial-selected");
			});
			thumbnail.classList.add("is-initial-selected");
			this.flkty.select(index);
		}
		setDraggable(draggable) {
			this.flkty.options.draggable = draggable;
			this.flkty.updateDraggable();
		}
		selectCell(mediaId) {
			this.flkty.selectCell(mediaId);
		}
		setupProductGallery() {
			if (!this.querySelectorAll(".product-single__media-zoom").length) {
				return;
			}
			this.setEventListeners();
			document.addEventListener("product:variant-change", (e) => {
				if (e.detail && e.detail.variantTitle && e.detail.variantTitle !== "Default Title") {
					this.dataset.variantTitle = e.detail.variantTitle;
				}
			});
		}
		buildItems() {
			this.activeImages = Array.from(
				this.querySelectorAll(".product-images__slide.is-active .product-single__media-image"),
			);

			return this.activeImages.map((item) => {
				let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

				let activelink = item.querySelector(".product-single__media-zoom");

				activelink.dataset.index = index;
				return {
					src: activelink.getAttribute("href"),
					msrc: activelink.dataset.msrc,
					w: activelink.dataset.w,
					h: activelink.dataset.h,
					thumbSrc: activelink.dataset.thumbSrc || activelink.dataset.msrc,
				};
			});
		}
		setEventListeners() {
			this.links = this.querySelectorAll(".product-single__media-zoom");
			this.pswpElement = document.querySelectorAll(".pswp")[0];

			this.pswpOptions = {
				maxSpreadZoom: 2,
				loop: true,
				allowPanToNext: true,
				closeOnScroll: false,
				showHideOpacity: false,
				arrowKeys: true,
				history: false,
				captionEl: false,
				fullscreenEl: false,
				zoomEl: false,
				shareEl: false,
				counterEl: true,
				arrowEl: true,
				preloaderEl: true,
				getThumbBoundsFn: () => {
					const thumbnail = this.querySelector(".product-images__slide.is-selected"),
						pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
						rect = thumbnail.getBoundingClientRect();
					return {
						x: rect.left,
						y: rect.top + pageYScroll,
						w: rect.width,
					};
				},
			};

			this.links.forEach((link) => {
				link.addEventListener("click", (e) => this.zoomClick(e, link));
			});
		}
		disconnectedCallback() {
			if (this.flkty) {
				this.flkty.destroy();
			}
		}
		buildPswpThumbnails(items) {
			const container = this.pswpElement.querySelector(".pswp__thumbs-inner");
			if (!container) return;
			container.innerHTML = "";
			if (this.dataset.lightboxThumbnails === "false" || items.length <= 1) {
				container.parentElement.style.display = "none";
				return;
			}
			container.parentElement.style.display = "";
			items.forEach((item, index) => {
				const thumb = document.createElement("div");
				thumb.className = "pswp__thumb";
				thumb.dataset.index = index;
				const img = document.createElement("img");
				img.src = item.thumbSrc;
				img.alt = "";
				img.loading = "lazy";
				thumb.appendChild(img);
				container.appendChild(thumb);
			});
		}
		updatePswpProductInfo() {
			const infoEl = this.pswpElement.querySelector(".pswp__product-info");
			if (!infoEl) return;
			if (this.dataset.lightboxProductInfo === "false") {
				infoEl.style.display = "none";
				return;
			}
			infoEl.style.display = "";
			const titleEl = infoEl.querySelector(".pswp__product-title");
			const variantEl = infoEl.querySelector(".pswp__variant-title");
			if (titleEl) titleEl.textContent = this.dataset.productTitle || "";
			if (variantEl) variantEl.textContent = this.dataset.variantTitle || "";
		}
		syncPswpThumbnails(index) {
			const container = this.pswpElement.querySelector(".pswp__thumbs-inner");
			if (!container) return;
			const thumbs = container.querySelectorAll(".pswp__thumb");
			thumbs.forEach((t, i) => {
				t.classList.toggle("is-active", i === index);
			});
			const activeThumb = container.querySelector(".pswp__thumb.is-active");
			if (activeThumb) {
				activeThumb.scrollIntoView({ inline: "center", behavior: "smooth", block: "nearest" });
			}
		}
		zoomClick(e, link) {
			this.items = this.buildItems();
			this.pswpOptions.index = parseInt(link.dataset.index, 10);
			if (typeof PhotoSwipe !== "undefined") {
				this.buildPswpThumbnails(this.items);
				this.updatePswpProductInfo();

				// Prevent touch/mouse events on bottom bar from reaching PhotoSwipe's gesture handler
				const bottomBar = this.pswpElement.querySelector(".pswp__bottom-bar");
				if (bottomBar) {
					["mousedown", "touchstart", "pointerdown"].forEach((evtName) => {
						bottomBar.addEventListener(evtName, (evt) => evt.stopPropagation());
					});
				}

				let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
				const _this = this;
				document.body.classList.add("open-lightbox");

				pswp.listen("firstUpdate", function () {
					pswp.listen("destroy", function () {
						document.body.classList.remove("open-lightbox");
					});
					pswp.listen("parseVerticalMargin", function (item) {
						item.vGap = {
							top: 50,
							bottom: 140,
						};
					});
				});

				// Reset any accidental parent scroll caused by loop transition
				const scrollWrap = this.pswpElement.querySelector(".pswp__scroll-wrap");
				const resetScroll = function () {
					if (scrollWrap) scrollWrap.scrollLeft = 0;
					_this.pswpElement.scrollLeft = 0;
				};

				pswp.listen("beforeChange", function () {
					const index = pswp.getCurrentIndex();
					_this.syncPswpThumbnails(index);
					resetScroll();
					// Sync product slideshow with lightbox
					if (_this.flkty) {
						_this.flkty.select(index);
					}
				});

				const thumbsInner = this.pswpElement.querySelector(".pswp__thumbs-inner");
				if (thumbsInner) {
					thumbsInner.addEventListener("click", function handler(evt) {
						evt.stopPropagation();
						const thumb = evt.target.closest(".pswp__thumb");
						if (thumb) {
							pswp.goTo(parseInt(thumb.dataset.index, 10));
							resetScroll();
						}
					});
				}

				pswp.listen("close", function () {
					const container = _this.pswpElement.querySelector(".pswp__thumbs-inner");
					if (container) container.innerHTML = "";
				});

				pswp.init();
				this.syncPswpThumbnails(this.pswpOptions.index);
			}
			e.preventDefault();
		}
	}
	customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();
			}
			connectedCallback() {
				this.sticky = this.dataset.sticky;
				this.form = document.getElementById(`product-form-${this.dataset.section}`);
				this.form.querySelector("[name=id]").disabled = false;
				if (!this.sticky) {
					this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				}
				this.cartNotification = document.querySelector("cart-notification");
				this.body = document.body;

				this.hideErrors = this.dataset.hideErrors === "true";
			}
			onSubmitHandler(evt) {
				evt.preventDefault();

				if (!this.form.reportValidity()) {
					return;
				}

				const submitButtons = document.querySelectorAll(".single-add-to-cart-button");

				submitButtons.forEach((submitButton) => {
					if (submitButton.classList.contains("loading")) return;
					submitButton.setAttribute("aria-disabled", true);
					submitButton.classList.add("loading");
				});

				this.handleErrorMessage();

				const config = {
					method: "POST",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Accept: "application/javascript",
					},
				};

				let formData = new FormData(this.form);

				formData.append(
					"sections",
					this.getSectionsToRender().map((section) => section.section),
				);
				formData.append("sections_url", window.location.pathname);
				config.body = formData;

				fetch(`${theme.routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							dispatchCustomEvent("product:variant-error", {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							if (response.status === 422) {
								document.documentElement.dispatchEvent(
									new CustomEvent("cart:refresh", {
										bubbles: true,
									}),
								);
							}
							this.handleErrorMessage(response.description);
							return;
						}

						this.renderContents(response);

						dispatchCustomEvent("cart:item-added", {
							product: response.hasOwnProperty("items") ? response.items[0] : response,
						});
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						submitButtons.forEach((submitButton) => {
							submitButton.classList.remove("loading");
							submitButton.removeAttribute("aria-disabled");
						});
					});
			}

			getSectionsToRender() {
				return [
					{
						id: "Cart",
						section: "main-cart",
						selector: ".thb-cart-form",
					},
					{
						id: "Cart-Drawer",
						section: "cart-drawer",
						selector: ".cart-drawer",
					},
					{
						id: "cart-drawer-toggle",
						section: "cart-bubble",
						selector: ".thb-item-count",
					},
				];
			}
			renderContents(parsedState) {
				this.getSectionsToRender().forEach((section) => {
					if (!document.getElementById(section.id)) {
						return;
					}
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector,
					);

					if (typeof Cart !== "undefined") {
						new Cart().renderContents(parsedState);
					}
				});

				let product_drawer = document.getElementById("Product-Drawer"),
					search_drawer = document.getElementById("Search-Drawer");

				if (search_drawer && OverlayManager.isOpen(search_drawer)) {
					OverlayManager.close(search_drawer);
				}
				if (product_drawer && product_drawer.contains(this)) {
					OverlayManager.close(product_drawer);
					if (document.getElementById("Cart-Drawer")) {
						document.getElementById("Cart-Drawer").open();
					}
				} else if (document.getElementById("Cart-Drawer")) {
					document.getElementById("Cart-Drawer").open();
				}
			}
			getSectionInnerHTML(html, selector = ".shopify-section") {
				return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
			}
			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		},
	);
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
/**
 * "Buy now": go straight to checkout after a successful add-to-cart; do not redirect on failure.
 *
 * Both sticky bars share this single copy — the theme's native <product-add-to-cart-sticky> (the snippet is currently
 * not referenced and is kept as a fallback, see snippets/product-information.liquid) and the custom
 * <product-sticky-cta>. The logic originally lived in the former's class methods; when the second consumer appeared it was extracted here
 * instead of making a second copy (the DRY hard rule in CLAUDE.md).
 *
 * Variant and quantity are both read live from the main form, so selections in bundle cards, color, and the quantity box follow automatically.
 *
 * @param {HTMLElement} button   the clicked button; owns the disabled / loading state
 * @param {string} sectionId     id of the section containing the main form
 * @param {Function} [onFailure] callback when add-to-cart fails; lets the caller fall back to its own error-message path
 */
window.__soulogBuyNow = function (button, sectionId, onFailure) {
	if (button.hasAttribute("disabled")) return;

	// Variant follows the main form: read the currently selected variant from the main form's input[name="id"]
	const form = document.getElementById(`product-form-${sectionId}`);
	const idInput = form && form.querySelector('input[name="id"]');
	const variantId = idInput && idInput.value;
	if (!variantId) return;

	const quantityInput = form && form.querySelector('input[name="quantity"]');
	const quantity = quantityInput && parseInt(quantityInput.value, 10) > 0 ? parseInt(quantityInput.value, 10) : 1;

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	const root = theme.routes.root_url || "/";
	const checkoutUrl = (root.endsWith("/") ? root.slice(0, -1) : root) + "/checkout";

	const recover = (data) => {
		button.removeAttribute("disabled");
		button.classList.remove("loading");
		if (typeof onFailure === "function") onFailure(data);
	};

	fetch(`${theme.routes.cart_add_url}`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
		},
		body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.status) {
				// Add-to-cart failed (e.g. out of stock): restore the button, do not redirect, hand the failure back to the caller
				recover(data);
				return;
			}
			window.location.href = checkoutUrl;
		})
		.catch(() => recover());
};

if (!customElements.get("product-add-to-cart-sticky")) {
	class ProductAddToCartSticky extends HTMLElement {
		connectedCallback() {
			this.setupObservers();
			this.setupBuyNow();
		}
		disconnectedCallback() {
			if (this.observer) {
				this.observer.disconnect();
			}
		}
		setupBuyNow() {
			const button = this.querySelector("[data-buy-now]");
			if (!button) return;

			button.addEventListener("click", () => window.__soulogBuyNow(button, this.dataset.section));
		}
		setupObservers() {
			let _this = this;
			this.observer = new IntersectionObserver(
				function (entries) {
					entries.forEach((entry) => {
						if (entry.target === footer) {
							if (entry.intersectionRatio > 0) {
								_this.classList.remove("sticky--visible");
							} else if (entry.intersectionRatio == 0 && _this.formPassed) {
								_this.classList.add("sticky--visible");
							}
						}
						if (entry.target === form) {
							let boundingRect = form.getBoundingClientRect();

							if (entry.intersectionRatio === 0 && window.scrollY > boundingRect.top + boundingRect.height) {
								_this.formPassed = true;
								_this.classList.add("sticky--visible");
							} else if (entry.intersectionRatio === 1) {
								_this.formPassed = false;
								_this.classList.remove("sticky--visible");
							}
						}
					});
				},
				{
					threshold: [0, 1],
				},
			);
			let form = document.getElementById(`product-form-${this.dataset.section}`),
				footer = document.getElementById("footer");
			_this.formPassed = false;
			this.observer.observe(form);
			this.observer.observe(footer);
		}
	}

	customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
	class ProductSidePanelLinks extends HTMLElement {
		constructor() {
			super();
			this.links = this.querySelectorAll("button");
			this.drawer = document.getElementById("Product-Information-Drawer");
			this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
			this.panels = this.drawer
				.querySelector(".side-panel-content--inner")
				.querySelectorAll(".side-panel-content--tab-panel");
			this.body = document.body;
		}
		connectedCallback() {
			this.setupObservers();
		}
		disconnectedCallback() {}
		setupObservers() {
			this.links.forEach((item, i) => {
				item.addEventListener("click", (e) => {
					this.buttons.toggleActiveClass(i);
					OverlayManager.open(this.drawer);
				});
			});
		}
	}

	customElements.define("side-panel-links", ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
	addIdToRecentlyViewed();
}
